import { Button }              from '@/components/ui/button';
import DeleteIcon              from '@/assets/icons/DeleteIcon';
import { DialogActionTrigger } from '@/components/ui/dialog';
import { DialogBody }          from '@/components/ui/dialog';
import { DialogCloseTrigger }  from '@/components/ui/dialog';
import { DialogContent }       from '@/components/ui/dialog';
import { DialogFooter }        from '@/components/ui/dialog';
import { DialogHeader }        from '@/components/ui/dialog';
import { DialogRoot }          from '@/components/ui/dialog';
import { DialogTitle }         from '@/components/ui/dialog';
import { DialogTrigger }       from '@/components/ui/dialog';
import authStore               from '@/stores/authStore';
import { toaster }             from '@/components/ui/toaster';
import { useTranslation }      from 'react-i18next';

interface IDeleteProfilePictureModalProps {
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteProfilePictureModal = (props: IDeleteProfilePictureModalProps) => {
	const { setIsLoading } = props;
	const currentUser = authStore.currentUser;
	const { t } = useTranslation();

	const deleteProfilePicture = async () => {
		setIsLoading(true);
		try {
			await currentUser.patch({
				userMediaProfilePicture: null
			});

			toaster.create({
                title: t('pages.personalInformation.personalInformationBox.modals.delete.success'),
                type: 'success'
            });
		} catch (error) {
			toaster.create({
                title: t('pages.personalInformation.personalInformationBox.modals.delete.error'),
                type: 'error'
            });
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	}

	return (
		<DialogRoot role="alertdialog">
			<DialogTrigger asChild>
				<Button 
					variant={"outline"} 
					width={{ base: "100%", lg: "fit-content" }}
					fontSize="14px"
					textWrap="wrap"
				>
					<DeleteIcon />
					{t('pages.personalInformation.personalInformationBox.form.actions.delete')}
				</Button>
			</DialogTrigger>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t('pages.personalInformation.personalInformationBox.modals.delete.title')}</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p>
						{t('pages.personalInformation.personalInformationBox.modals.delete.message')}
					</p>
				</DialogBody>
				<DialogFooter>
					<DialogActionTrigger asChild>
						<Button variant="outline">{t('pages.personalInformation.personalInformationBox.modals.delete.cancel')}</Button>
					</DialogActionTrigger>
					<Button bg="red" height="40px" color="white" onClick={deleteProfilePicture}>{t('pages.personalInformation.personalInformationBox.modals.delete.confirm')}</Button>
				</DialogFooter>
				<DialogCloseTrigger />
			</DialogContent>
		</DialogRoot>
	)
}

export default DeleteProfilePictureModal